var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// import React from "react";
// import {
//   LoginAFY,
//   LoginAFY2,
// } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
// const Login_ah: React.FC = () => {
//   return (
//     <>
//       {/* <LoginAFY
//       onSignIn={props.onSingIn}
//       title={props.title}
//       logo={props.logo}
//       emailError={props.emailError}
//       emailRequired={props.emailRequired}
//       emailText={props.emailText}
//       emailHelperText={props.emailHelperText}
//       passwordHelperText={props.passwordHelperText}
//       passwordText={props.passwordText}
//       passwordError={props.passwordError}
//       passwordRequired={props.passwordRequired}
//       labelButtonLogin={props.labelButtonLogin}
//       labelButtonForgetPassword={props.labelButtonForgetPassword}
//       labelInputPassword={props.labelInputPassword}
//       userForm={props.userForm}
//       onClickForgetPassword={props.onClickForgetPassword}
//       showSSO={props.showSSO}
//       onSubmitSSO={props.onSubmitSSO}
//       labelButtonLoginSSO={props.labelButtonLoginSSO}
//     /> */}
//       <LoginAFY2 {...props} />
//     </>
//   );
// };
import { LoginAFY2, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
export var LoginView_ah = function (props) {
    return _jsx(LoginAFY2, __assign({}, props));
};
